<ap-icon-button-link
    id="previousButton"
    class="ap-margin-top-1 ap-margin-bottom-1 ap-display-inline-block"
    iconName="chevron-left"
    iconSize="medium"
>
    {{ 'general.question.previous' | apContent }}</ap-icon-button-link
>
